import { c as _c } from "react/compiler-runtime";
import { useTruncation } from "@/hooks/use-truncation";
import { CopyButton } from "@domainstack/ui/copy-button";
import { ResponsiveTooltip, ResponsiveTooltipContent, ResponsiveTooltipTrigger } from "@domainstack/ui/responsive-tooltip";
import { cn } from "@domainstack/ui/utils";
type KeyValueProps = {
  label?: string;
  value: React.ReactNode;
  copyable?: boolean;
  leading?: React.ReactNode;
  highlight?: boolean;
  trailing?: React.ReactNode;
  suffix?: React.ReactNode;
  valueTooltip?: React.ReactNode;
};
export function KeyValue(t0) {
  const $ = _c(36);
  const {
    label,
    value,
    copyable,
    leading,
    highlight,
    trailing,
    suffix,
    valueTooltip
  } = t0;
  const {
    valueRef,
    isTruncated
  } = useTruncation();
  const copyText = typeof value === "string" ? value : undefined;
  const t1 = highlight ? "border-accent-purple/20 bg-background/60 bg-linear-to-r from-accent-purple/5 to-transparent dark:border-accent-purple/12" : "border-border bg-background/60";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("flex h-16 min-w-0 items-center justify-between gap-4 rounded-lg border px-4 py-3 backdrop-blur-lg", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== highlight || $[3] !== label) {
    t3 = label && <div className={cn("pt-1 text-[10px] leading-none tracking-[0.08em] uppercase", highlight ? "text-accent-purple" : "text-foreground/75 dark:text-foreground/80")}>{label}</div>;
    $[2] = highlight;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== leading) {
    t4 = leading ? <span className="h-4 w-4 rounded leading-none [&>img]:block [&>img]:h-full [&>img]:w-full [&>svg]:block [&>svg]:h-full [&>svg]:w-full">{leading}</span> : null;
    $[5] = leading;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== value || $[8] !== valueRef) {
    t5 = <ResponsiveTooltipTrigger nativeButton={false} render={<span ref={valueRef} className="min-w-0 flex-1 truncate">{value}</span>} />;
    $[7] = value;
    $[8] = valueRef;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== isTruncated || $[11] !== value || $[12] !== valueTooltip) {
    t6 = isTruncated || valueTooltip != null ? <ResponsiveTooltipContent className="max-w-[80vw] break-words whitespace-pre-wrap md:max-w-[40rem]">{valueTooltip ?? value}</ResponsiveTooltipContent> : null;
    $[10] = isTruncated;
    $[11] = value;
    $[12] = valueTooltip;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <ResponsiveTooltip>{t5}{t6}</ResponsiveTooltip>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== suffix) {
    t8 = suffix ? <span className="leading-none [&_img]:block [&_img]:h-4 [&_img]:w-4 [&_span]:leading-none [&_svg]:block [&_svg]:h-4 [&_svg]:w-4">{suffix}</span> : null;
    $[17] = suffix;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t4 || $[20] !== t7 || $[21] !== t8) {
    t9 = <div className="inline-flex min-w-0 items-center gap-1.5 text-[13px] text-foreground/95">{t4}{t7}{t8}</div>;
    $[19] = t4;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t3 || $[24] !== t9) {
    t10 = <div className="flex min-w-0 flex-col space-y-1.5">{t3}{t9}</div>;
    $[23] = t3;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== copyText || $[27] !== copyable) {
    t11 = copyable && copyText != null && <CopyButton value={copyText} variant="ghost" className="-mr-1 text-muted-foreground" />;
    $[26] = copyText;
    $[27] = copyable;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t11 || $[30] !== trailing) {
    t12 = <div className="flex shrink-0 items-center gap-2">{trailing}{t11}</div>;
    $[29] = t11;
    $[30] = trailing;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t10 || $[33] !== t12 || $[34] !== t2) {
    t13 = <div className={t2}>{t10}{t12}</div>;
    $[32] = t10;
    $[33] = t12;
    $[34] = t2;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  return t13;
}